"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropositionDuration;
(function (PropositionDuration) {
    PropositionDuration["1YEAR"] = "1_year";
    PropositionDuration["2YEARS"] = "2_years";
    PropositionDuration["3YEARS"] = "3_years";
    PropositionDuration["5YEARS"] = "5_years";
    PropositionDuration["OBT"] = "obt";
    PropositionDuration["FLEX"] = "flex";
})(PropositionDuration || (PropositionDuration = {}));
exports.default = PropositionDuration;
